module.exports = "<div class=\"ppa-client-add\"><ppa-tenant-form on-submit=\"vm.submitTenant\" tenant=\"vm.tenant\"></ppa-tenant-form></div>";